const ROLE_ALIASES = {
  admin: "Admin",
  superadmin: "Admin",
  adminstaff: "AdminStaff",
  admin_staff: "AdminStaff",
  "admin personeli": "AdminStaff",
  accountant: "Accountant",
  muhasebeci: "Accountant",
  secretary: "Secretary",
  sekreter: "Secretary",
  doctor: "Doctor",
  doktor: "Doctor",
  clinicstaff: "ClinicStaff",
  clinic_staff: "ClinicStaff",
  "klinik personeli": "ClinicStaff",
  clinicmanager: "ClinicManager",
  clinic_manager: "ClinicManager",
  klinikyonetici: "ClinicManager",
  "klinik yöneticisi": "ClinicManager",
  pharmacist: "Pharmacist",
  eczaci: "Pharmacist",
  "eczacı": "Pharmacist",
  dietitian: "Dietitian",
  diyetisyen: "Dietitian",
  patient: "Patient",
  hasta: "Patient",
  patientrelative: "PatientRelative",
  "hasta yakını": "PatientRelative",
  hastayakini: "PatientRelative",
};

export const normalizeRole = (value) => {
  const raw = String(value || "").trim().toLowerCase();
  return ROLE_ALIASES[raw] || value;
};

export const getRoleLabel = (value) => {
  switch (normalizeRole(value)) {
    case "Admin":
      return "Sistem Yöneticisi";
    case "AdminStaff":
      return "Admin Personeli";
    case "Accountant":
      return "Muhasebeci";
    case "Secretary":
      return "Sekreter";
    case "Doctor":
      return "Doktor";
    case "ClinicStaff":
      return "Klinik Personeli";
    case "ClinicManager":
      return "Yönetici";
    case "Pharmacist":
      return "Eczacı";
    case "Dietitian":
      return "Diyetisyen";
    case "Patient":
      return "Hasta";
    case "PatientRelative":
      return "Hasta Yakını";
    default:
      return value || "-";
  }
};
